import { render, staticRenderFns } from "./DashboardDetailsList.vue?vue&type=template&id=8699492e&scoped=true&"
import script from "./DashboardDetailsList.vue?vue&type=script&lang=js&"
export * from "./DashboardDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDetailsList.vue?vue&type=style&index=0&id=8699492e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8699492e",
  null
  
)

export default component.exports